let API_URL: string;
let TEAM_LOGO_URL: string;
let LEAGUE_LOGO_URL: string;
let SPONSOR_LOGO_URL: string;
let UPLOADED_IMAGE_URL: string;
let CONTENT_IMAGE_URL: string;
let UPLOADED_COI_URL: string;
let STRIPE_LINK: string;
let STRIPE_REDIRECT: string;
let SITE_URL: string;

export const SITE_ID = 1;
export const MAX_FILE_SIZE = 8388608;

export const VALID_FILE_EXTENSIONS = {
    image: ["jpg", "png", "jpeg", "gif"],
    file: ["pdf", "png"],
} as const;

switch (process.env.BUILD_ENV) {
    case "development":
    case "test":
        API_URL = "http://localhost:10601";
        TEAM_LOGO_URL =
            "https://baseball365-test-images.s3.amazonaws.com/logos/teams/";
        LEAGUE_LOGO_URL =
            "https://baseball365-test-images.s3.amazonaws.com/logos/leagues/";
        SPONSOR_LOGO_URL =
            "https://baseball365-test-images.s3.amazonaws.com/logos/sponsors/";
        UPLOADED_IMAGE_URL =
            "https://baseball365-test-images.s3.amazonaws.com/submittedPhotos/";
        CONTENT_IMAGE_URL =
            "https://baseball365-test-images.s3.amazonaws.com/contentPhotos/";
        STRIPE_LINK = "https://dashboard.stripe.com/test/payments/";
        STRIPE_REDIRECT = "http://localhost:10200/thankyou";
        SITE_URL = "http://localhost:10200";
        UPLOADED_COI_URL =
            "https://baseball365-test-files.s3.amazonaws.com/coi/";
        break;
    case "stage":
        API_URL = "https://test.api.majorybl.com";
        TEAM_LOGO_URL =
            "https://baseball365-test-images.s3.amazonaws.com/logos/teams/";
        LEAGUE_LOGO_URL =
            "https://baseball365-test-images.s3.amazonaws.com/logos/leagues/";
        SPONSOR_LOGO_URL =
            "https://baseball365-test-images.s3.amazonaws.com/logos/sponsors/";
        UPLOADED_IMAGE_URL =
            "https://baseball365-test-images.s3.amazonaws.com/submittedPhotos/";
        CONTENT_IMAGE_URL =
            "https://baseball365-test-images.s3.amazonaws.com/contentPhotos/";
        STRIPE_LINK = "https://dashboard.stripe.com/test/payments/";
        STRIPE_REDIRECT = "http://test.majorybl.com/thankyou";
        UPLOADED_COI_URL =
            "https://baseball365-test-files.s3.amazonaws.com/coi/";
        SITE_URL = "http://test.majorybl.com";
        break;
    case "production":
        API_URL = "https://api.majorybl.com";
        TEAM_LOGO_URL =
            "https://baseball365-images.s3.amazonaws.com/logos/teams/";
        LEAGUE_LOGO_URL =
            "https://baseball365-images.s3.amazonaws.com/logos/leagues/";
        SPONSOR_LOGO_URL =
            "https://baseball365-images.s3.amazonaws.com/logos/sponsors/";
        UPLOADED_IMAGE_URL =
            "https://baseball365-images.s3.amazonaws.com/submittedPhotos/";
        CONTENT_IMAGE_URL =
            "https://baseball365-images.s3.amazonaws.com/contentPhotos/";
        UPLOADED_COI_URL = "https://baseball365-files.s3.amazonaws.com/coi/";
        STRIPE_LINK = "https://dashboard.stripe.com/payments/";
        STRIPE_REDIRECT = "https://www.majorybl.com/thankyou";
        SITE_URL = "https://www.majorybl.com";
        break;
}

export {
    API_URL,
    TEAM_LOGO_URL,
    LEAGUE_LOGO_URL,
    SPONSOR_LOGO_URL,
    UPLOADED_IMAGE_URL,
    CONTENT_IMAGE_URL,
    STRIPE_LINK,
    STRIPE_REDIRECT,
    UPLOADED_COI_URL,
    SITE_URL,
};

export const PHONE_REGEXP =
    /^(?:\+1)?[-. ]?(?:\(\d{3}\)|\d{3})[-. ]?\d{3}[-. ]?\d{4}$/;

export const AUTH_LEVELS = {
    all: [1, 2, 3, 4, 5, 6],
    clubhouse: [1, 2, 3, 4, 5],
    leaguemanagement: [1, 2],
    sitemanagement: [1, 2],
    org: [4],
};

export const AWS_REGION = "us-east-1";
